export default __webpack_public_path__ + "static/media/img-0772-sweden-full-face.67a53800.png";